<section class="br-card br-card--dense br-mt-3" aria-labelledby="company-information-heading">
  <header class="br-card-header br-flex br-items-center br-justify-between br-gap-2">
    <h2 id="company-information-heading" class="br-card-title br-mb-0">Company information</h2>
    <button *ngIf="!editing && canManage" type="button" class="br-btn br-btn--sm" (click)="edit()" [disabled]="busy || !loaded">Edit</button>
  </header>
  <div *ngIf="!editing" class="br-card-body">
    <p *ngIf="busy" role="status" class="br-text-muted br-mb-0">Loading company information…</p>
    <div *ngIf="error" role="alert"><p class="br-text-danger">{{ error }}</p><button type="button" class="br-btn br-btn--sm" (click)="load()">Retry</button></div>
    <dl *ngIf="loaded" class="br-record-rows">
      <dt>Company name</dt><dd>{{ profile.profile().name }}</dd>
      <dt>Address</dt><dd>{{ profile.address() || 'Not set' }}</dd>
    </dl>
    <p *ngIf="saved" role="status" class="br-small br-text-success br-mt-2 br-mb-0">Saved.</p>
  </div>
  <form *ngIf="editing" class="br-card-body" [formGroup]="form" (ngSubmit)="save()">
    <p *ngIf="error" role="alert" class="br-text-danger">{{ error }}</p>
    <div class="br-mb-3">
      <span class="br-form-label">Company name</span>
      <p class="br-mb-1">{{ profile.profile().name }}</p>
      <p class="br-small br-text-muted br-mb-0">Used for sign-in. Company name cannot be changed here.</p>
    </div>
    <div class="br-row br-g-3">
      <div *ngFor="let field of fields" class="br-col-12" [class.br-col-sm-6]="field.key !== 'street'">
        <label class="br-form-label" [for]="'company-' + field.key">{{ field.label }}</label>
        <input class="br-form-control" [id]="'company-' + field.key" [formControlName]="field.key" [attr.autocomplete]="field.autocomplete"
          [readOnly]="busy || !canManage" [attr.maxlength]="field.maxLength">
      </div>
    </div>
    <div class="br-flex br-flex-wrap br-items-center br-justify-end br-gap-2 br-mt-3">
      <button type="button" class="br-btn br-btn--secondary" (click)="cancel()" [disabled]="busy">Cancel</button>
      <button type="submit" class="br-btn br-btn--primary" [disabled]="busy || !loaded || !canManage || form.invalid || !form.dirty">Save</button>
    </div>
  </form>
</section>
